module.exports = __webpack_public_path__ + "static/img/1.fe2a490.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1.png
// module id = A1tS
// module chunks = 1